export const EXTERNAL_LINKS = {
  PTU_ARTICLE:
    'https://support.worky.mx/hc/es-419/articles/42728411907603--C%C3%B3mo-realiz%C3%B3-el-c%C3%A1lculo-de-PTU',
};
